<template>
  <div class="order-wrap">
    <div class="order-tabs">
      <button
        v-for="t in tabs"
        :key="t.status"
        :class="['tab', activeTab === t.status && 'is-active']"
        @click="changeTab(t.status)"
      >{{ t.title }}</button>

      <div class="search">
        <el-input
          v-model="keyword"
          placeholder="按标段、保函编号搜索"
          @keyup.enter.native="search"
        >
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
        <button class="g-btn g-btn-primary" @click="search">查询</button>
      </div>
    </div>

    <div v-if="list.length" class="order-grid">
      <article
        v-for="(item, index) in list"
        :key="index"
        class="order-card"
      >
        <header class="card-head">
          <div class="title">
            <span class="name ellipsis">{{ item.tendName }}</span>
            <order-tag-group :item="item" />
          </div>
          <div class="amount">
            <span>保函金额</span>
            <strong class="num">¥ {{ formatMoney(item.prjEarMoney) }}</strong>
          </div>
        </header>

        <div class="card-grid">
          <div><label>标段编号</label><span>{{ item.tendNo }}</span></div>
          <div><label>保函编号</label><span>{{ item.gatNo || '-' }}</span></div>
          <div><label>保函类型</label><span>{{ item.dbType || '-' }}</span></div>
          <div><label>申请时间</label><span>{{ formatDate(item.createdAt) }}</span></div>
          <div><label>开标时间</label><span>{{ item.tendStDate }}</span></div>
        </div>

        <footer class="card-foot">
          <button class="g-btn g-btn-default" @click="toDetail(item.orderNo)">查看详情</button>
          <button
            class="g-btn g-btn-default"
            v-if="canSurrender(item)"
            @click="surrender('2', item.orderId)"
          >申请退保</button>
          <button
            class="g-btn g-btn-default"
            v-if="canSurrender(item)"
            @click="surrender('3', item.orderId)"
          >申请理赔</button>
          <button
            class="g-btn g-btn-default"
            v-if="canReSurrender(item)"
            @click="surrender('2', item.orderId)"
          >重新退保</button>
          <button
            class="g-btn g-btn-default"
            v-if="canReSurrender(item)"
            @click="revert(item)"
          >撤销退保</button>
          <button
            class="g-btn g-btn-primary"
            v-if="canApplyInvoice(item)"
            @click="applyInvoice(item)"
          >申请发票</button>
          <button
            class="g-btn g-btn-primary"
            v-if="item.state == '0' || item.state == '1'"
            @click="toPay(item)"
          >立即支付</button>
        </footer>
      </article>
    </div>

    <div v-else class="g-empty">
      <img src="@/assets/noData.png" />
      <p>暂无订单</p>
      <button class="g-btn g-btn-primary" style="margin-top: 16px" @click="$router.push('/project')">去申请</button>
    </div>

    <el-pagination
      v-if="list.length"
      background
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="pageNum"
      @current-change="fetch"
      class="pager"
    />
  </div>
</template>

<script>
import OrderTagGroup from '@/components/OrderTagGroup'
import { getOrderList, postCkType, reCkType } from '@/lib/api/order'
import { ckInvoice, pay } from '@/lib/api/attestation'
import { formatDate, formatMoney } from './ucHelpers'

export default {
  name: 'OrderList',
  components: { OrderTagGroup },
  data () {
    return {
      activeTab: '',
      keyword: '',
      pageNum: 1,
      total: 0,
      list: [],
      tabs: [
        { status: '', title: '全部' },
        { status: '0', title: '申请中' },
        { status: '1', title: '已申请' },
        { status: '2', title: '已取消' }
      ]
    }
  },
  computed: {
    params () {
      return {
        orderNo: 'null',
        status: this.activeTab,
        name: this.keyword,
        pageSize: 10,
        pageNum: this.pageNum
      }
    }
  },
  watch: {
    '$route.query.tab' (t) { if (t === 'order') this.fetch() }
  },
  created () { this.fetch() },
  methods: {
    formatDate, formatMoney,
    fetch () {
      getOrderList(this.params).then((res) => {
        if (res.code === 200) {
          this.list = res.rows || []
          this.total = res.total || 0
        }
      })
    },
    changeTab (status) {
      this.activeTab = status
      this.pageNum = 1
      this.fetch()
    },
    search () { this.pageNum = 1; this.fetch() },
    canSurrender (item) {
      if (item.type === '2' || item.type === '3') return false
      if (item.status === '1' && (item.state === '0' || item.state === '1')) return false
      if (item.status === '2') return false
      return new Date().getTime() < new Date(item.prjEndEarDate).getTime()
    },
    canReSurrender (item) {
      return item.type === '2' && item.status === '2'
    },
    canApplyInvoice (item) {
      return item.type !== '2' && item.type !== '3' && item.state === '3' && item.invoice === '1'
    },
    surrender (type, orderId) {
      const isCancel = type === '2' ? '退保' : '理赔'
      this.$prompt(`请输入${isCancel}理由`, '提示', {
        confirmButtonText: '提交',
        cancelButtonText: '取消',
        inputType: 'textarea'
      }).then(({ value }) => {
        postCkType({ type, orderId, value }).then((res) => {
          if (res.code === 200) {
            this.$message.success(res.msg)
            this.fetch()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    revert (item) {
      this.$confirm('确定撤销？', '提示', { type: 'warning' }).then(() => {
        reCkType({ type: '2', orderId: item.orderId }).then((res) => {
          if (res.code === 200) { this.$message.success(res.msg); this.fetch() }
        })
      }).catch(() => {})
    },
    applyInvoice (item) {
      this.$confirm('确定申请发票？', '提示', { type: 'warning' }).then(() => {
        ckInvoice({ orderId: item.orderId }).then((res) => {
          if (res.code === 200) {
            this.$message.success('申请成功，请联系客户经理')
            this.fetch()
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    toPay (item) {
      pay({ wayCode: 'WX_NATIVE', id: item.orderId }).then((res) => {
        this.$emit('open-pay', res.data)
      })
    },
    toDetail (orderNo) {
      this.$router.push({ path: '/orderDetail', query: { orderNo } })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.order-wrap { padding: 4px; }

.order-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  .tab {
    height: 32px;
    padding: 0 18px;
    border-radius: @radius-full;
    background: #fff;
    border: 1px solid @border-base;
    color: @text-secondary;
    font-size: 13px;
    cursor: pointer;
    transition: all @duration-fast @ease-out;

    &:hover { color: @primary; border-color: @primary; }
    &.is-active {
      background: @primary;
      color: #fff;
      border-color: @primary;
    }
  }

  .search {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 10px;
    width: 320px;

    ::v-deep .el-input__inner {
      border-radius: @radius-full;
      height: 36px;
    }
  }
}

.order-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.order-card {
  background: #fff;
  border-radius: @radius-lg;
  padding: 20px 24px;
  box-shadow: @shadow-sm;
  border: 1px solid transparent;
  transition: box-shadow @duration-base @ease-out;

  &:hover { box-shadow: @shadow-md; border-color: @primary-soft; }
}

.card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
  border-bottom: 1px dashed @border-light;

  .title {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;

    .name {
      font-size: 16px;
      font-weight: 600;
      color: @text-strong;
      max-width: 320px;
    }
  }

  .amount {
    text-align: right;
    span {
      display: block;
      color: @text-muted;
      font-size: 12px;
      margin-bottom: 4px;
    }
    .num {
      color: @danger;
      font-size: 18px;
      font-weight: 700;
    }
  }
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px 24px;
  padding: 18px 0;

  > div {
    display: flex;
    gap: 6px;
    font-size: 13px;

    label { color: @text-muted; flex-shrink: 0; }
    span { color: @text-base; }
  }
}

.card-foot {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding-top: 4px;

  .g-btn {
    height: 32px;
    padding: 0 14px;
    font-size: 13px;
  }
}

.pager {
  margin-top: 24px;
  text-align: center;
}
</style>
